module.exports = __webpack_public_path__ + "img/table.64c8f4ff.png";